import { useCallback } from 'react';

import type { Flash } from './flashesStore';
import { createZustandContextStore } from './utils/createZustandContextStore';

type HorizonFlashStoreState = {
  flash: Flash | null;
};

const {
  ZustandContextProvider,
  useZustandContextStore,
  useZustandContextSelector,
} = createZustandContextStore<HorizonFlashStoreState>({
  fallbackState: {
    flash: null,
  },
});

export const HorizonFlashStoreProvider = ZustandContextProvider;

// Hooks

export function useHorizonFlash(): {
  horizonFlash: Flash | null;
} {
  const horizonFlash = useZustandContextSelector((state) => state.flash);

  return { horizonFlash };
}

export function useHorizonFlashActions() {
  const store = useZustandContextStore();

  const clearHorizonFlash = useCallback(() => {
    store.setState({ flash: null });
  }, [store]);

  return { clearHorizonFlash };
}
